import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=75ccf7fb&"
import script from "./Collapsible.vue?vue&type=script&lang=js&"
export * from "./Collapsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ccf7fb')) {
      api.createRecord('75ccf7fb', component.options)
    } else {
      api.reload('75ccf7fb', component.options)
    }
    module.hot.accept("./Collapsible.vue?vue&type=template&id=75ccf7fb&", function () {
      api.rerender('75ccf7fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/Collapsible.vue"
export default component.exports